const mixin = {
  filters: {
    deDash(string) {
      if (string != null) {
        return string.replace('_', ' ')
      }
    }
  }
}

export default mixin
